import React from "react";
import "./styles.scss";
const BottomBar = (props) => {
  return (
    <div className="bottombar-container">
      <div className="button-container">
        <button
          className="button-back"
          onClick={props.handleBackButton}
          type="button"
        >
          Back
        </button>
        <button
          className="button-next"
          onClick={props.handleNextButton}
          disabled={props.disabled}
          type="button"
        >
          {props?.forwardBtnText ? props.forwardBtnText : "Next"}
        </button>
      </div>
    </div>
  );
};

export default BottomBar;
